import Button, { ButtonProps } from '../Button';
import SVG from '../SVG';

interface FormButtonProps extends ButtonProps {
  loading?: boolean;
}

export default function FormButton({ ...rest }: FormButtonProps) {
  return <Button {...rest} />;
}
